module.exports = __webpack_public_path__ + "img/login_04.52c73318.png";